// extracted by mini-css-extract-plugin
export default {"rankContainer":"Rank_rankContainer__JRuJl","sort":"Rank_sort__Umj0F"};